var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgProfile16X16 = function SvgProfile16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.485 3.515A11.922 11.922 0 0012 0a11.921 11.921 0 00-8.485 3.515A11.921 11.921 0 000 12c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0012 24c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0024 12c0-3.205-1.248-6.219-3.515-8.485zM6.015 20.737A6.059 6.059 0 0112 15.716a6.059 6.059 0 015.984 5.02A10.534 10.534 0 0112 22.595c-2.219 0-4.28-.687-5.984-1.857zm2.17-10.243A3.82 3.82 0 0112 6.678a3.82 3.82 0 013.816 3.816A3.82 3.82 0 0112 14.309a3.82 3.82 0 01-3.816-3.815zm11.017 9.268a7.474 7.474 0 00-2.184-3.52 7.476 7.476 0 00-2.173-1.372 5.221 5.221 0 002.377-4.376A5.228 5.228 0 0012 5.272a5.228 5.228 0 00-5.222 5.222c0 1.83.947 3.444 2.377 4.376a7.477 7.477 0 00-2.173 1.372 7.476 7.476 0 00-2.184 3.52A10.567 10.567 0 011.406 12C1.406 6.159 6.16 1.406 12 1.406c5.841 0 10.594 4.753 10.594 10.594 0 3.063-1.307 5.826-3.392 7.762z",
    fill: "#9CA6AD"
  })));
};

export default SvgProfile16X16;